module.exports = __webpack_public_path__ + "img/register_qrcode.1e715510.png";